import { Typography } from '@mui/material'
import moment from 'moment'
import React, { useMemo, useState } from 'react'

interface DateExpiredProps {
  date: string
  setExpired: (isExpired: boolean) => void
}

const ExpiryLabel: React.FC<DateExpiredProps> = ({ date, setExpired }) => {
  const [isExpired, setIsExpired] = useState(false)
  const expiryStatus = useMemo(() => {
    const expiryDate = moment(date)
    const now = moment()
    const daysLeft = expiryDate.diff(now, 'days')

    if (daysLeft > 0) {
      setExpired(false)
      setIsExpired(false)
      return `Expires in ${daysLeft} day${daysLeft > 1 ? 's' : ''}`
    } else if (daysLeft === 0) {
      setExpired(false)
      setIsExpired(false)
      return 'Expires today'
    } else {
      setExpired(true)
      setIsExpired(true)
      return `Expired`
    }
  }, [date])
  return (
    <Typography
      variant="subtitle2"
      color="grey.600"
      textAlign="start"
      alignSelf="flex-start"
      fontWeight={600}
      p={1}
      borderRadius="12px"
      bgcolor={isExpired ? 'grey.100' : 'secondary.50'}
    >
      {expiryStatus}
    </Typography>
  )
}

export default ExpiryLabel
